import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {MapComponent} from '../map.component';

@Component({
  selector: 'player-comp',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss'],
  
})

export class PlayerComponent implements OnDestroy, AfterViewInit, OnInit {

  constructor(public mapComp: MapComponent) {

  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
  }

  setSpeed() {
    if (this.mapComp.playingSpeed == 0.025) {
      this.mapComp.playingSpeed = 0.0075;
    } else {
      this.mapComp.playingSpeed += 0.005;
    }
    if (this.mapComp.playingSpeedX == 4) {
      this.mapComp.playingSpeedX = 0.5;
    } else if (this.mapComp.playingSpeedX == 2) {
      this.mapComp.playingSpeedX = 4;
    } else {
      this.mapComp.playingSpeedX += 0.5;
    }
    console.log(this.mapComp.playingSpeed)
  }
}
